/** An element's content box, in CSS px. */
export interface BoxSize {
  width: number;
  height: number;
}

const sizeWatchers = new Map<Element, (size: BoxSize) => void>();
let sizeObserver: ResizeObserver | undefined;

/**
 * Calls `onSize` with `element`'s content box once it is watched and whenever it changes, until
 * the returned stop. One ResizeObserver serves every element. Where nothing can watch (no
 * ResizeObserver), once, from its client size. One watcher per element.
 */
export function onResize(element: Element, onSize: (size: BoxSize) => void): () => void {
  if (typeof ResizeObserver !== "function") {
    onSize({ width: element.clientWidth, height: element.clientHeight });
    return () => {};
  }
  sizeObserver ??= new ResizeObserver((entries) => {
    for (const entry of entries) {
      const { width, height } = entry.contentRect;
      sizeWatchers.get(entry.target)?.({ width, height });
    }
  });
  sizeWatchers.set(element, onSize);
  sizeObserver.observe(element);
  return () => {
    sizeWatchers.delete(element);
    sizeObserver?.unobserve(element);
  };
}
